import React, { useState, useCallback, memo } from 'react';
import PillMenu from '../../common/menu/PillMenu';
import AgentServicesList from './AgentServicesList';

import styles from '../../store/styles/StoreContainer.module.css';

const TABS = [
  { id: 'discover', label: 'Discover' },
  { id: 'added', label: 'Added Services' },
  { id: 'owned', label: 'Owned Services' },
];

const AgentServicesContainer = ({ agentId }) => {
  const [activeTab, setActiveTab] = useState('discover');

  const handleTabChange = useCallback(tabId => {
    setActiveTab(tabId);
  }, []);

  const renderTabContent = useCallback(() => {
    switch (activeTab) {
      case 'discover':
        return <AgentServicesList agentId={agentId} type="discover" />;
      case 'added':
        return <AgentServicesList agentId={agentId} type="added" />;
      case 'owned':
        return <AgentServicesList agentId={agentId} type="owned" />;
      default:
        return null;
    }
  }, [activeTab, agentId]);

  return (
    <div className={styles.agentServicesContainer}>
      <div className={styles.content}>
        <div className={styles.tabRow} style={{ padding: '0' }}>
          <div className={styles.tabsWrapper}>
            <PillMenu tabs={TABS} activeTab={activeTab} onTabChange={handleTabChange} />
          </div>
        </div>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default memo(AgentServicesContainer);
